import Text from '@/components/ui/text/text';
import { useStyles } from '@/features/player/components/list-player/player-card/player-card-root';

export const PlayerCardTitle = ({ title }: { title: string }) => {
  const styles = useStyles();

  return (
    <Text
      variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px"
      transform="uppercase"
      fontWeight="800"
      numberOfLines={1}
      ellipsizeMode="tail"
      style={styles.playerName}>
      {title}
    </Text>
  );
};
